import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  private readonly accessTokenKey = 'accessToken';

  setAccessToken(token: string): void {
    window.sessionStorage.setItem(this.accessTokenKey, token);
  }

  getAccessToken(): string | null {
    return window.sessionStorage.getItem(this.accessTokenKey);
  }

  clear(): void {
    window.sessionStorage.removeItem(this.accessTokenKey);
  }
}
